import io from "socket.io-client";

export const socket = io('https://xocdia.xanhchin.io');